import React from "react";
import { Box, Grid } from "@mui/material";
import ReviewFormDetails from "components/Reviews/ReviewFormDetails";
import ReviewFormType from "components/Reviews/ReviewFormType";
import ReviewFormTitle from "components/Reviews/ReviewFormTitle";
import ReviewCard from "components/Reviews/ReviewCard";
import { useGetReviews } from "hooks/queries/useGetReviews";

const Reviews = () => {
  const { reviews } = useGetReviews();

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={5}>
        <ReviewFormDetails />
        <ReviewFormType />
      </Grid>
      <Grid item xs={12} md={7}>
        <ReviewFormTitle />
        {reviews?.map((review) => (
          <Box key={review.id}>
            <ReviewCard
              review={review}
            />
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default Reviews;
